import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';


@Component({
  selector: 'app-dashboard',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  submited: boolean = false;
  resetForm: FormGroup;

  constructor(public router: Router, private fb: FormBuilder) { }

  ngOnInit() {
    this.resetForm = this.fb.group({
      email: ['', Validators.compose([Validators.email, Validators.required])]
    })
  }

  onSubmit() {
    if(this.resetForm.valid) {
      this.submited = !this.submited;
    }
    
  }
}



// @Component({
//   selector: 'app-dashboard',
//   templateUrl: 'reset-password.component.html'
// })
